import { UPDATE_ADDRESS_VERIFICATION_LAT_LONG, UPDATE_ADDRESS_VERIFICATION_MAP_POINT, LOAD_ADDRESS_VERIFICATION_PAGE } from 'constants/ActionTypes';

const loadAddressVerificationPage = (reportId) => ({ type: LOAD_ADDRESS_VERIFICATION_PAGE, reportId });
const updateAddressVerificationMapPoint = (mapPoint) => ({ type: UPDATE_ADDRESS_VERIFICATION_MAP_POINT, mapPoint });
const updateAddressVerificationLatitudeLongitude = (newPinLocation) => ({ type: UPDATE_ADDRESS_VERIFICATION_LAT_LONG, newPinLocation });

export { loadAddressVerificationPage, updateAddressVerificationMapPoint, updateAddressVerificationLatitudeLongitude };
